import { Injectable } from '@angular/core';
import { CurrentApiService, ElementsService } from 'dbweb-core';
import { tap } from 'rxjs/operators';

export interface UpdateData {
	FromEle: string;
	CountNum: number;
	Fields: [];
}

// UpdateFieldSetting å­æ®µåå®¹
export interface UpdateFieldSetting {
	selected?: boolean;
	setValue?: string;
	Name: string;
	Label: string;
	Tooltip: string;
	Freeentry: boolean; // æ¯å¦åè®¸èªç±å½å¥
	Must: boolean; // å¿å¡«
	List: {
		Value: string;
		Label: string;
	}[]; // nil-èªç±å½å¥ï¼å¶ä»æ¯éå®å¼
}

export interface SetData {
	Column: string;
	Value: string;
}

export interface DoUpdateParam {
	Sets: SetData[];
}
export interface DoUpdateResult {
	TaskID: string;
	Timeout: boolean;
	TaskInfoURL: string; // å¯¹åºçæå¼ä»»å¡ä¿¡æ¯çURL
	TaskInfoSign: string; // ä¸è¿°çsign
}

@Injectable({
	providedIn: 'root'
})
export class UpdateService {
	public num: number;
	public eleName: string;
	public fields: UpdateFieldSetting[];
	public taskInfoURL: string;
	public step = '';
	constructor(private eles: ElementsService, private api: CurrentApiService) {}
	init() {
		this.step = 'prepare';
		return this.api.get<UpdateData>('get-update-data').subscribe(v => {
			this.eleName = v.FromEle;
			this.num = v.CountNum;
			this.fields = v.Fields;
		});
	}

	doUpdate(param: DoUpdateParam) {
		return this.api.post<DoUpdateResult>('do-update', param).pipe(
			tap(v => {
				// æ³¨åæ¥çä»»å¡æç»çurl
				this.eles.setURLSign(v.TaskInfoURL, v.TaskInfoSign);
			})
		);
	}
}
